
import React from 'react'
import Cart from '../Components/cart/Cart'

function ProductPage() {
  return (
    <Cart/>
  )
}

export default ProductPage